var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M19.7694 5.88823C19.9838 5.08803 19.5089 4.26552 18.7087 4.05111L5.66874 0.557054C4.86854 0.342641 4.04603 0.817515 3.83162 1.61771C3.61721 2.41791 4.09208 3.24042 4.89228 3.45483L16.4834 6.56066L13.3776 18.1518C13.1631 18.952 13.638 19.7745 14.4382 19.9889C15.2384 20.2033 16.0609 19.7284 16.2753 18.9282L19.7694 5.88823ZM1.75 16.799L19.0705 6.79904L17.5705 4.20096L0.25 14.201L1.75 16.799Z",
    fill: "white",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.221f0ad6c851fd6ba6a873a6f8b53688.svg";
export { ForwardRef as ReactComponent };